import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import {QueryClientProvider,QueryClient} from '@tanstack/react-query';
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';
import {QueryLoadingBoundary} from './components/index';
import { Toaster } from 'react-hot-toast';
import { ScrollToTop } from './components/shared/index';

const queryClient = new QueryClient();
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
   <QueryLoadingBoundary>

   <ReactQueryDevtools initialIsOpen={true}/> 
      <BrowserRouter>
      <ScrollToTop/>
      <Toaster
  position="top-right"
  reverseOrder={false}
    containerStyle={{
    zIndex: 99999999,
  }}
  toastOptions={{
    duration: 1000,

    style: {
      color: "white",
      padding: "10px 14px",
      borderRadius: "12px",
      fontSize: "15px",
      fontWeight: "500",
    },

    // SUCCESS → GREEN
    success: {
      style: {
        background: "#3ac65b",
        color: "white",
        boxShadow: "0 8px 25px rgba(40, 167, 69, 0.35)",
      },
      iconTheme: {
        primary: "#fff",
        secondary: "#3ac65b",
      },
    },

    // ERROR → RED
    error: {
      style: {
        background: "#e53b4c",
        color: "#fff",
        boxShadow: "0 8px 25px rgba(231, 105, 117, 0.35)",
      },
      iconTheme: {
        primary: "#fff",
        secondary: "#e53b4c",
      },
    },
  }}
/>
         <App />  
      </BrowserRouter>
   </QueryLoadingBoundary>
   </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();